module.exports = __webpack_public_path__ + "files/f881193f5c393a33790a1954bb386d68.png";